export const ITEMS_PER_PAGE = 25

export const sortOptions = {
  RELEVANCE: '_text_match(buckets: 15):desc,sales_rank:asc',
  DATE_ADDED_NEW_TO_OLD: 'date_added:desc',
  DATE_ADDED_OLD_TO_NEW: 'date_added:asc',
} as const

